import axios from "axios";

export class ServiceSupplierInsuranceReminderController {
  async unsubscribeEmailNotifications({ p, s }: { p: string, s: string }): Promise<string> {
    const response = await axios.post(`/api/organizations/superadmin/supplier-insurance-reminder/unsubscribe/${p}/${s}`);
    return response.data;
  }
  async fetchStatus({ p, s }: { p: string, s: string }): Promise<boolean> {
    const response = await axios.get(`/api/organizations/superadmin/supplier-insurance-reminder/unsubscribe/status/${p}/${s}`);
    return response.data.status;
  }
}

export const ServiceSupplierInsuranceReminder = new ServiceSupplierInsuranceReminderController();
